export const DEFAULT_CUSTOMER_CATEGORIES = [
    {
        code: 'RETAIL',
        name: 'Einzelhandel',
        translations: {
            de: 'Einzelhandel',
            en: 'Retail',
            fr: 'Commerce de détail',
            es: 'Venta al por menor',
            tr: 'Perakende',
        },
        sortOrder: 0,
        isActive: true,
        usageCount: 0,
        id: 'RETAIL',
    },
    {
        code: 'WHOLESALE',
        name: 'Großhandel',
        translations: {
            de: 'Großhandel',
            en: 'Wholesale',
            fr: 'Vente en gros',
            es: 'Venta al por mayor',
            tr: 'Toptan Satış',
        },
        sortOrder: 10,
        isActive: true,
        usageCount: 0,
        id: 'WHOLESALE',
    },
    {
        code: 'MANUFACTURING',
        name: 'Produktion',
        translations: {
            de: 'Produktion',
            en: 'Manufacturing',
            fr: 'Fabrication',
            es: 'Fabricación',
            tr: 'İmalat',
        },
        sortOrder: 20,
        isActive: true,
        usageCount: 0,
        id: 'MANUFACTURING',
    },
    {
        code: 'GASTRONOMY',
        name: 'Gastronomie',
        translations: {
            de: 'Gastronomie',
            en: 'Gastronomy',
            fr: 'Gastronomie',
            es: 'Gastronomía',
            tr: 'Gastronomi',
        },
        sortOrder: 30,
        isActive: true,
        usageCount: 0,
        id: 'GASTRONOMY',
    },
    {
        code: 'LOGISTICS',
        name: 'Logistik',
        translations: {
            de: 'Logistik',
            en: 'Logistics',
            fr: 'Logistique',
            es: 'Logística',
            tr: 'Lojistik',
        },
        sortOrder: 40,
        isActive: true,
        usageCount: 0,
        id: 'LOGISTICS',
    },
    {
        code: 'HEALTHCARE',
        name: 'Gesundheitswesen',
        translations: {
            de: 'Gesundheitswesen',
            en: 'Healthcare',
            fr: 'Santé',
            es: 'Salud',
            tr: 'Sağlık Hizmeti',
        },
        sortOrder: 50,
        isActive: true,
        usageCount: 0,
        id: 'HEALTHCARE',
    },
    {
        code: 'PUBLIC_SECTOR',
        name: 'Öffentlicher Sektor',
        translations: {
            de: 'Öffentlicher Sektor',
            en: 'Public sector',
            fr: 'Secteur public',
            es: 'Sector público',
            tr: 'Kamu sektörü',
        },
        sortOrder: 60,
        isActive: true,
        usageCount: 0,
        id: 'PUBLIC_SECTOR',
    },
    {
        code: 'CONSTRUCTION',
        name: 'Bau',
        translations: {
            de: 'Bau',
            en: 'Construction',
            fr: 'Construction',
            es: 'Construcción',
            tr: 'İnşaat',
        },
        sortOrder: 70,
        isActive: true,
        usageCount: 0,
        id: 'CONSTRUCTION',
    },
    {
        code: 'AGRICULTURE',
        name: 'Landwirtschaft',
        translations: {
            de: 'Landwirtschaft',
            en: 'Agriculture',
            fr: 'Agriculture',
            es: 'Agricultura',
            tr: 'Tarım',
        },
        sortOrder: 80,
        isActive: true,
        usageCount: 0,
        id: 'AGRICULTURE',
    },
    {
        code: 'SERVICES',
        name: 'Dienstleistung',
        translations: {
            de: 'Dienstleistung',
            en: 'Services',
            fr: 'Prestations',
            es: 'Servicios',
            tr: 'Hizmetler',
        },
        sortOrder: 90,
        isActive: true,
        usageCount: 0,
        id: 'SERVICES',
    },
    {
        code: 'OTHER',
        name: 'Sonstige',
        translations: {
            de: 'Sonstige',
            en: 'Other',
            fr: 'Autre',
            es: 'Otros',
            tr: 'Diğer',
        },
        sortOrder: 100,
        isActive: true,
        usageCount: 0,
        id: 'OTHER',
    },
];
//# sourceMappingURL=customer-categories.js.map